module.exports = __webpack_public_path__ + "fa-solid-900.8c3a8870b9d83594cf83.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-solid-900.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.eot
// module chunks = styles